import React from 'react';
import { PleriConversationStatus } from '../../api/conversations';

interface ConversationStatusBadgeProps {
  status?: PleriConversationStatus;
  hasErrors?: boolean | null;
  className?: string;
}

export const ConversationStatusBadge: React.FC<
  ConversationStatusBadgeProps
> = ({ status, className = '' }) => {
  return (
    <span
      className={`inline-flex rounded-md px-2 py-1 text-xs font-medium ${
        status === PleriConversationStatus.Completed
          ? 'bg-green-100 text-green-700 dark:bg-green-900'
          : status === PleriConversationStatus.Failed
            ? 'bg-red-100 text-red-700 dark:bg-red-900'
            : status === PleriConversationStatus.Running
              ? 'bg-blue-100 text-blue-700 dark:bg-blue-900'
              : status === PleriConversationStatus.Thinking
                ? 'bg-amber-100 text-amber-700 dark:bg-amber-900'
                : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300'
      } ${className}`}
    >
      {status}
    </span>
  );
};
